// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__13spL","search":"Settings_search__3_-lK","filter":"Settings_filter__3ZIuL"};